import { RouteName } from './routeNames'

export const routesDebug = [
  {
    path: '/debug',
    name: RouteName.Debug,
    component: () => import('../views/debug/DebugView.vue')
  },
  {
    path: '/debug/native',
    name: RouteName.DebugDeviceApi,
    component: () => import('../views/debug/DebugDeviceApiView.vue')
  },
  {
    path: '/debug/locale',
    name: RouteName.DebugLocale,
    component: () => import('../views/debug/DebugLocaleView.vue')
  },
  {
    path: '/debug/push-message/register-fcm-token',
    name: RouteName.DebugRegisterFcmToken,
    component: () => import('../views/debug/DebugRegisterFcmTokenView.vue')
  },
  {
    path: '/debug/ui-dialog',
    name: RouteName.DebugUiDialog,
    component: () => import('../views/debug/DebugUiDialogView.vue')
  },
  {
    path: '/debug/ui-bottom-sheet',
    name: RouteName.DebugUiBottomSheet,
    component: () => import('../views/debug/DebugUiBottomSheetView.vue')
  },
  {
    path: '/debug/envs',
    name: RouteName.DebugEnvs,
    component: () => import('../views/debug/DebugEnvsView.vue')
  },
  {
    path: '/debug/jsonform',
    name: RouteName.DebugJsonForm,
    component: () => import('../views/debug/DebugJsonFormView.vue')
  },
  {
    path: '/debug/miniconfig',
    name: RouteName.DebugMiniConfig,
    component: () => import('../views/debug/DebugMiniConfig.vue')
  }
] as const

export const routeNamesDebug = routesDebug.map((r) => r.name)
